import { Component, Input } from '@angular/core';
import { LayoutService } from '../../layout/layout.service';

@Component({
    selector: 'app-client-view',
    templateUrl: './client-view.component.html',
    standalone: false,
})
export class ClientViewComponent {
    // @ts-ignore TS7008
    @Input() customer;

    constructor(private layoutService: LayoutService) {}

    showSecondaryNav() {
        return this.layoutService.showSecondaryNav();
    }

    getSecondaryNavClasses() {
        return this.layoutService.getSecondaryNavClasses();
    }
}
